import * as React from 'react';
import { ComponentProps, FileUploader } from 'ui';
import { MdAttachFile } from 'react-icons/md';
import { withOpenState, OpenStateInjectedProps } from 'ui/common/enhancers/with-open-state';
import { LinkToModalView } from 'ui/link-to-modal-view/link-to-modal-view';

interface LinkButtonFileUploaderProps {
  textHeaderTitle?: string;
  textHeaderInfo?: string;
  textDone?: string;
  textNoUserEmailExist?: string;
  textGoToProfile?: string;
}
export type LinkButtonFileUploaderComponentProps = ComponentProps & OpenStateInjectedProps & LinkButtonFileUploaderProps;

export class LinkButtonFileUploaderComponent extends React.PureComponent<LinkButtonFileUploaderComponentProps> {

  public render() {
    const {
      componentId  
    } = this.props; 

    return (
      <div id={componentId}>
        <LinkToModalView 
          content={<FileUploader {...this.props}/>}
          icon={<MdAttachFile />} 
          {...this.props}
        />
      </div>
    );
  }
}

const c = withOpenState()(LinkButtonFileUploaderComponent);

export { c as LinkButtonFileUploader };
